import * as React from "react";
import type { SVGProps } from "react";
const SvgShieldSecurity = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={80}
    height={80}
    fill="none"
    {...props}
  >
    <path
      fill="#79AFFF"
      d="M36.533 7.033 18.2 13.9c-3.5 1.333-6.367 5.467-6.367 9.233v27c0 2.7 1.767 6.267 3.933 7.867L34.1 71.7c3.233 2.433 8.533 2.433 11.766 0L64.2 58c2.166-1.633 3.933-5.167 3.933-7.867v-27c0-3.733-2.867-7.9-6.367-9.2L43.433 7.067c-1.867-.734-5-.734-6.9-.034Z"
      opacity={0.4}
    />
    <path
      fill="#79AFFF"
      d="M48.334 35c0-4.6-3.734-8.333-8.334-8.333A8.336 8.336 0 0 0 31.667 35c0 3.733 2.467 6.833 5.833 7.9v8.767c0 1.366 1.134 2.5 2.5 2.5 1.367 0 2.5-1.134 2.5-2.5V42.9c3.367-1.067 5.834-4.167 5.834-7.9Z"
    />
  </svg>
);
export default SvgShieldSecurity;
